import { render } from "./Final.vue?vue&type=template&id=e88b0ff2&scoped=true"
import script from "./Final.vue?vue&type=script&lang=js"
export * from "./Final.vue?vue&type=script&lang=js"

import "./Final.vue?vue&type=style&index=0&id=e88b0ff2&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/CERAMICAS/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e88b0ff2"]])

export default __exports__